import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Seo from "../common/Seo";
import { fetchLegalPagePublic } from "../../services/cmsClient";

export default function LegalPage({ slug: propSlug }) {
  const params = useParams();
  const slug = propSlug || params.slug || "privacy-policy";
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError("");
    fetchLegalPagePublic(slug)
      .then((data) => {
        if (alive) setPage(data);
      })
      .catch((e) => {
        if (alive) setError(e.message || "This page is not available.");
      })
      .finally(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, [slug]);

  const title = page?.title || "Legal page";

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50/70 via-amber-50/25 to-stone-100 px-4 py-10 sm:py-14">
      <Seo
        title={`${title} | MyMomDad`}
        description={page?.metaDescription || page?.summary || "Legal information."}
        canonical={propSlug ? `/${propSlug}` : `/legal/${slug}`}
        noIndex
      />
      <div className="mx-auto max-w-4xl">
        <div className="mb-6 sm:mb-8">
          <p className="text-xs font-bold uppercase tracking-widest text-stone-500">
            Legal
          </p>
          <h1 className="mt-2 text-3xl font-extrabold tracking-tight text-stone-900 sm:text-4xl">
            {title}
          </h1>
          {page?.updatedAt ? (
            <p className="mt-2 text-sm text-stone-600">
              Last updated:{" "}
              <span className="font-semibold text-stone-700">
                {new Date(page.updatedAt).toLocaleDateString()}
              </span>
            </p>
          ) : null}
          {page?.summary ? (
            <p className="mt-3 text-sm leading-6 text-stone-700">{page.summary}</p>
          ) : null}
        </div>

        <section className="rounded-2xl border border-stone-200/80 bg-white p-5 shadow-sm sm:p-6">
          {loading ? (
            <p className="text-sm text-stone-600">Loading page...</p>
          ) : error ? (
            <div className="space-y-3 text-sm leading-6 text-stone-700">
              <p>{error}</p>
              <p>
                Please visit the{" "}
                <Link
                  to="/contact"
                  className="font-semibold text-orange-700 underline underline-offset-4"
                >
                  Contact
                </Link>{" "}
                page if you need help.
              </p>
            </div>
          ) : (
            <div
              className="prose prose-stone max-w-none text-sm leading-6 text-stone-700"
              dangerouslySetInnerHTML={{ __html: page?.bodyHtml || "" }}
            />
          )}
        </section>
      </div>
    </div>
  );
}
